import { PDFDocument } from "pdf-lib";
import { generaPDF, getListaAllegati } from "./service";
import { NotificationManager } from "react-notifications";

const base64ToArrayBuffer = (base64) => {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

const displayPDF = async (pdfDocument) => {
  const pdfBytes = await pdfDocument.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank");
  window.URL.revokeObjectURL(url);
};

// cosi facci anche il download
// const displayPDF = async (pdfDocument, title) => {
//   const pdfBytes = await pdfDocument.save();
//   const blob = new Blob([pdfBytes], { type: "application/pdf" });
//   const url = window.URL.createObjectURL(blob);

//   // 1) apri preview
//   window.open(url, "_blank", "noopener,noreferrer");

//   // 2) scarica con nome
//   const fileName = `${title}_${Date.now()}.pdf`; // oppure usa idAccettazione ecc.
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = fileName; // <-- QUI il nome .pdf
//   document.body.appendChild(a);
//   a.click();
//   a.remove();

//   // non revocare subito, altrimenti la tab appena aperta può diventare vuota
//   setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
// };

const handlePdfFattura = async (data) => {
  try {
    const mergedPdf = await PDFDocument.create();
    const arrayBuffer = base64ToArrayBuffer(data);
    const singlePdf = await PDFDocument.load(arrayBuffer);
    const copiedPages = await mergedPdf.copyPages(
      singlePdf,
      singlePdf.getPageIndices()
    );
    copiedPages.forEach((page) => mergedPdf.addPage(page));
    displayPDF(mergedPdf);
  } catch (error) {
    NotificationManager.error(
      "Errore durante il caricamento del PDF",
      "Attenzione"
    );
    console.error("Errore durante il caricamento del PDF:", error);
  }
};

const handlePdfView = async (
  dispatch,
  gruppo,
  idAnagrafica,
  idGrandeCliente,
  idAccettazione,
  elencoIDAllegati = []
) => {
  try {
    let data = [];

    if (gruppo === -1) {
      // usa gli id passati dal chiamante
      data = elencoIDAllegati;
    } else {
      // comportamento originale
      data = await dispatch(getListaAllegati(gruppo));
    }

    if (data.length > 0) {
      const mergedPdf = await PDFDocument.create();

      for (const idAllegato of data) {
        const response = await dispatch(
          generaPDF({
            idAllegato,
            idStruttura: 0,
            idAnagrafica,
            idGrandeCliente,
            idAccettazione,
            testo: "",
          })
        );

        if (response.isSuccess) {
          const arrayBuffer = base64ToArrayBuffer(response.data);
          const singlePdf = await PDFDocument.load(arrayBuffer);
          const copiedPages = await mergedPdf.copyPages(
            singlePdf,
            singlePdf.getPageIndices()
          );
          copiedPages.forEach((page) => mergedPdf.addPage(page));
        } else {
          console.log(response.message);
        }
      }

      displayPDF(mergedPdf);
    } else {
      NotificationManager.warning("Nessun allegato trovato", "Attenzione");
    }
  } catch (error) {
    NotificationManager.error(
      "Errore durante il caricamento del PDF",
      "Attenzione"
    );
    console.error("Errore durante il caricamento del PDF:", error);
  }
};

export { handlePdfView, handlePdfFattura };
